import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "core-js/modules/es.array.push.js";
import img1 from '@/assets/renz/renz_img3.jpg';
import { postShiming2, getCode } from '@/api/user';
export default {
  components: {
    [_Dialog.Component.name]: _Dialog.Component
  },
  data() {
    return {
      img1,
      countDownNum: 60,
      timerTf: true,
      timer: null,
      username: '',
      value4: '',
      value5: '',
      value1: '',
      value2: '',
      value3: '',
      pattern: /\d{17}([0-9]|x|X)/
    };
  },
  methods: {
    receiveCode() {
      let params = {
        phone: this.value3
      };
      getCode(params).then(resp => {
        if (resp.code == 200) {
          _Toast('发送成功');
          this.timerTf = false;
          this.countDownNum = 60;
          this.timer = setInterval(() => {
            this.countDownNum--;
            if (this.countDownNum <= 0) {
              this.timerTf = true;
              clearInterval(this.timer);
            }
          }, 1000);
        } else {
          _Toast('提示内容');
        }
      });
    },
    validator(val) {
      return /1\d{10}/.test(val);
    },
    onSubmit(values) {
      if (this.value1 != this.value2) {
        _Toast('两次密码不一致');
        return;
      }
      let postData = values;
      postShiming2(postData).then(resp => {
        if (resp.code == 200) {
          // this.$router.push('shiming3')
          //添加实名flag
          let uinfo = JSON.parse(localStorage.getItem('xinguserInfo'));
          if (uinfo) {
            uinfo.isMing = 1;
          } else {
            uinfo = Object.assign({
              isMing: 1
            }, uinfo);
          }
          localStorage.setItem('xinguserInfo', JSON.stringify(uinfo));
          _Toast("认证成功");
          this.$router.push('/');
        } else {
          _Toast(resp.message);
        }
      });
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    }
  }
};